export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8654.55f92689.jpg";